import { LinkProviderType } from 'owa-fileprovider-link';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';
import { setFileName } from '../mutators/collabSpaceMutators';
import { defaultCollabSpaceName } from '../components/CollabSpace.locstring.json';
import loc from 'owa-localize';
import { trace } from 'owa-trace';
import { lazyGetSharingInformation } from 'owa-sharing-data';

export async function setFileNameFromSharingInfo(url: string, viewStateId: string) {
    if (url?.length > 0) {
        const getSharingInformation = await lazyGetSharingInformation.import();
        getSharingInformation(
            url,
            LinkProviderType.OneDrivePro,
            false /* shouldUseReadWriteServer */
        )
            .then((sharingInfo: GetSharingInfoResponse) => {
                if (sharingInfo?.FileName) {
                    setFileName(sharingInfo.FileName, viewStateId);
                } else {
                    setFileName(loc(defaultCollabSpaceName), viewStateId);
                }
            })
            .catch(e => {
                // Set as default fluid file name in case of any errors
                setFileName(loc(defaultCollabSpaceName), viewStateId);
                trace.warn('Unable to retrieve sharing information for ' + url);
            });
    } else {
        setFileName(loc(defaultCollabSpaceName), viewStateId);
    }
}
